export enum PagePaths {
  admin = "/admin",
  users = "/admin/users",
  organizations = "/admin/organizations",
  platforms = "/admin/platforms",
  documents = "/admin/documents",
  contents = "/admin/contents",
  streams = "/admin/streams",
  streamEntrypoints = "/admin/stream-entrypoints",
  collectionTypes = "/admin/collection-types",
  migrations = "/admin/migrations",
  queues = "/admin/queues",
  mailerConfigs = "/admin/mailer-configs",
  configs = "/admin/configs",
  languages = "/admin/languages",
  translations = "/admin/translations",
  payments = "/admin/payments",
  refunds = "/admin/refunds",
  disputes = "/admin/disputes",
  productPurchases = "/admin/product-purchases",
  subscriptions = "/admin/subscriptions",
  billingContracts = "/admin/billing/contracts",
  billingPayments = "/admin/billing/payments",
  billingReports = "/admin/billing/reports",
  billingSeller = "/admin/billing/seller",
  assistantConversations = "/admin/assistant/conversations",
  assistantRequests = "/admin/assistant/requests",
  assistantPlans = "/admin/assistant/plans",
  assistantUsage = "/admin/assistant/usage",
  billingExpenses = "/admin/billing/expenses",
}
